var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _path13, _circle6, _circle7, _circle8, _circle9, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _circle16, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShovelVault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 298 172",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f5ff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M269.522 19.986H28.48v132.028h241.042z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ec4f6",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M297.381 24.832h-54.507v121.127h54.507z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M287.691 46.634h-35.127v9.69h35.127z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcf0da",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M287.691 58.747h-9.69v9.69h9.69z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M287.691 70.86h-9.69v9.69h9.69z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcf0da",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M287.691 82.972h-9.69v9.69h9.69z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M274.973 58.747h-9.69v9.69h9.69z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcf0da",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M274.973 70.86h-9.69v9.69h9.69z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M274.973 82.972h-9.69v9.69h9.69z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcf0da",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M274.973 95.085h-9.69v9.69h9.69zm-12.719-36.338h-9.69v9.69h9.69z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M262.254 70.86h-9.69v9.69h9.69z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcf0da",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M262.254 82.972h-9.69v9.69h9.69z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M287.69 117.493h-35.126m35.126 4.845h-35.126m35.126 4.845h-35.126",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.221 159.638a.962.962 0 100-1.924h-4.132v-4.132a.962.962 0 10-1.924 0v4.132H7.033a.962.962 0 000 1.924h4.132v4.132a.962.962 0 101.924 0v-4.132h4.132zm93.625 4.667a.605.605 0 000-1.211h-2.601v-2.601a.606.606 0 10-1.211 0v2.601h-2.601a.605.605 0 100 1.211h2.601v2.6a.605.605 0 101.211 0v-2.6h2.601z",
    fill: "#18191b",
    fillRule: "nonzero"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 279.817,
    cy: 155.042,
    r: 3.028,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "rotate(90 279.817 155.042)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.775,
    cy: 164.733,
    r: 1.817,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "rotate(90 38.775 164.733)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 3.028,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "matrix(0 1 1 0 18.184 10.901)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.184,
    cy: 3.634,
    r: 3.028,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "rotate(90 104.184 3.634)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.409,
    cy: 167.155,
    r: 4.239,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "rotate(90 214.409 167.155)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M279.432 7.653a.385.385 0 000-.77h-1.652V5.23a.386.386 0 00-.77 0v1.653h-1.653a.385.385 0 000 .77h1.653v1.652a.385.385 0 10.77 0V7.653h1.652z",
    fill: "#18191b",
    fillRule: "nonzero"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "matrix(0 1 1 0 33.93 7.268)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "matrix(0 1 1 0 289.507 15.746)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "matrix(0 1 1 0 211.986 8.479)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 59.958,
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "matrix(-1 0 0 1 149 86)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M148.662 40.707c-1.64.878-3.666 1.285-5.728 1.425-2.068.14-4.215.013-6.126-.208-.846-.098-1.636.344-2.097 1.035-.46.688-.536 1.531-.081 2.216l5.555 8.368c1.195 1.801.175 4.177-1.656 4.997-3.38 1.513-7.037 4.184-10.295 7.268-3.257 3.083-6.077 6.543-7.801 9.606-2.554 4.538-4.999 9.945-6.267 15.086-1.274 5.167-1.326 9.928.72 13.29 3.094 5.083 8.394 6.865 11.171 7.202.492.059.964.204 1.402.413 1.647.789 7.552 3.06 20.917 3.06 13.382 0 19.555-2.277 21.296-3.068.464-.211.96-.338 1.463-.384 2.141-.193 6.199-1.351 9.203-4.916 4.107-4.874 5.806-17.653-4.767-31.809-6.55-8.771-13.509-13.531-17.916-15.648-1.791-.86-2.691-3.238-1.494-4.979l7.568-11.006c.718-1.045.165-2.392-1.014-2.602-1.961-.348-4.55-.69-7.125-.687-2.589.003-5.091.357-6.928 1.341z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#383c42",
    strokeWidth: 1.21
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.209 52.084c3.084 0 6.53.633 8.79 1.171 1.01.24 1.692 1.157 1.692 2.196 0 1.422-1.256 2.52-2.67 2.371-2.299-.243-5.317-.489-7.812-.489-2.638 0-6.004.275-8.475.531-1.329.137-2.531-.826-2.656-2.156-.109-1.157.637-2.222 1.774-2.462 2.539-.536 6.289-1.162 9.357-1.162z",
    fill: "#31c48d",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.578 71.465v21.803m3.634-21.803c0 4.109 1.211 8.199 1.211 12.307v9.496",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M154.895 77.359c-.271-1.227-1.54-2.25-2.699-2.727-.847-.349-1.76-.47-2.663-.623-.553-.094-1.102-.178-1.655-.074-.731.137-1.509.096-2.208.364-1.442.553-2.854 1.426-3.654 2.74-.601.988-.588 2.18-.513 3.289.024.349.062.841.353 1.087.477.402 1.029.756 1.619.978.784.295 1.641.52 2.48.593.968.084 1.927.385 2.864.632 1.015.267 2.014.543 2.967.978.296.135.561.41.834.588.308.202.581.403.83.671.337.364.92.711 1.088 1.178.337.935.54 1.897.517 2.887-.01.465-.35 1.592-.968 1.692-.396.064-.809.301-1.182.455-.844.347-1.827.637-2.725.822-.882.181-1.868.292-2.77.346-.614.037-1.277.068-1.883-.06-1.448-.307-2.261-1.61-3.194-2.61-.625-.671-1.152-1.426-1.811-2.065m4.845 4.768v3.633m4.845-4.845v4.845",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M221.646 108.637l.143-9.165-12.569 22.212-.143 9.165 12.569-22.212zm-68.236-.556l.135-8.656 55.674 22.259-.143 9.165-55.666-22.768z",
    fill: "#bcf0da",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.506 101.971l19.237 7.431m-19.301-3.357l9.618 3.715m46.049 19.053l-18.728-7.423m18.783 3.858l-12.148-4.773",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.645 81.883l-18.091 17.033 55.666 22.768 12.569-22.212-50.144-17.589z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M220.999 101.677l-51.314-26.759-16.39 18.184 52.095 29.111 15.609-20.536z",
    fill: "#bcf0da",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M193.16 97.828c-.419 2.926-3.582 5.048-7.238 4.524-3.657-.523-6.096-3.448-5.677-6.374.419-2.926 3.581-5.048 7.238-4.525 3.656.524 6.096 3.448 5.677 6.375zm-17.425-7.64c-.18 1.256-1.569 2.25-3.277 2.006-1.707-.245-2.761-1.589-2.581-2.845.179-1.256 1.568-2.25 3.276-2.005 1.708.244 2.762 1.588 2.582 2.844zm29.665 15.565c-.18 1.256-1.569 2.25-3.277 2.006-1.707-.245-2.761-1.589-2.582-2.845.18-1.256 1.569-2.25 3.277-2.005 1.707.244 2.761 1.588 2.582 2.844z",
    fill: "#31c48d",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.017 107.845l-32.123-48.138-23.115 8.062 31.677 50.575 23.561-10.499z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M192.46 91.083c-1.775 2.364-5.568 2.704-8.522.486-2.954-2.217-3.687-5.954-1.913-8.319 1.775-2.364 5.568-2.704 8.523-.486 2.954 2.217 3.687 5.954 1.912 8.319zm-11.605-15.078c-.762 1.014-2.458 1.218-3.837.183-1.38-1.036-1.658-2.721-.896-3.736.762-1.014 2.457-1.218 3.837-.183 1.38 1.036 1.657 2.721.896 3.736zm18.525 27.913c-.762 1.015-2.457 1.218-3.837.183-1.38-1.036-1.658-2.721-.896-3.736.762-1.014 2.457-1.218 3.837-.183 1.38 1.036 1.658 2.721.896 3.736z",
    fill: "#31c48d",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.827 106.969l.558-8.638-57.276 17.734-.591 9.147 57.309-18.243z",
    fill: "#bcf0da",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.222 100.872l-19.769 5.867m19.507-1.803l-9.885 2.934M85.65 123.179l19.262-5.9m-19.033 2.343l12.491-3.786",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M126.748 79.396l16.67 18.426-57.309 18.242-10.752-23.146 51.391-13.522z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.968 95.18l53.29-22.569 14.883 19.437-54.257 24.851L75.968 95.18z",
    fill: "#bcf0da",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M104.025 93.569c.184 2.95 3.167 5.319 6.853 5.089 3.687-.229 6.353-2.949 6.169-5.899-.183-2.951-3.166-5.319-6.853-5.09-3.686.23-6.352 2.95-6.169 5.9zm17.981-6.221c.079 1.266 1.383 2.368 3.105 2.261 1.722-.107 2.88-1.363 2.801-2.629-.079-1.266-1.383-2.368-3.105-2.261-1.722.107-2.88 1.362-2.801 2.629zM91.191 100.49c.078 1.267 1.383 2.369 3.105 2.261 1.722-.107 2.88-1.362 2.801-2.628-.079-1.267-1.384-2.369-3.105-2.261-1.722.107-2.88 1.362-2.801 2.628z",
    fill: "#31c48d",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M93.591 128.57l51.108-27.151 16.528 18.059-51.871 29.508-15.765-20.416z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.4 124.507c.441 2.923 3.62 5.021 7.272 4.47 3.652-.552 6.07-3.495 5.629-6.418-.442-2.923-3.62-5.021-7.273-4.469-3.652.551-6.07 3.494-5.628 6.417zm17.366-7.772c.189 1.255 1.586 2.238 3.291 1.981 1.706-.258 2.75-1.61 2.56-2.864-.189-1.255-1.585-2.238-3.291-1.981-1.706.258-2.75 1.61-2.56 2.864zm-29.546 15.791c.189 1.254 1.586 2.238 3.291 1.98 1.706-.257 2.75-1.609 2.56-2.864-.189-1.254-1.585-2.238-3.291-1.98-1.706.257-2.75 1.609-2.56 2.864z",
    fill: "#31c48d",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.701 130.607l51.108-27.151 16.529 18.059-51.871 29.508-15.766-20.416z",
    fill: "#bcf0da",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.51 126.544c.442 2.923 3.62 5.021 7.273 4.469 3.652-.551 6.07-3.494 5.628-6.417-.441-2.923-3.62-5.021-7.272-4.469-3.653.551-6.07 3.494-5.629 6.417zm17.367-7.772c.189 1.254 1.585 2.238 3.291 1.98 1.706-.257 2.75-1.609 2.56-2.864-.189-1.254-1.586-2.238-3.291-1.98-1.706.257-2.75 1.609-2.56 2.864zm-29.546 15.791c.189 1.254 1.585 2.238 3.291 1.98 1.706-.257 2.75-1.609 2.56-2.864-.189-1.254-1.585-2.238-3.291-1.98-1.706.257-2.75 1.609-2.56 2.864z",
    fill: "#31c48d",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M104.793 132.643l51.108-27.15 16.529 18.059-51.871 29.507-15.766-20.416z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M132.602 128.581c.442 2.923 3.62 5.021 7.273 4.469 3.652-.551 6.07-3.494 5.628-6.417-.441-2.923-3.62-5.021-7.272-4.469-3.653.551-6.07 3.494-5.629 6.417zm17.367-7.773c.189 1.255 1.585 2.238 3.291 1.981 1.706-.258 2.75-1.61 2.56-2.864-.189-1.255-1.586-2.238-3.291-1.981-1.706.258-2.75 1.61-2.56 2.864zM120.423 136.6c.189 1.254 1.586 2.238 3.291 1.98 1.706-.257 2.75-1.609 2.56-2.864-.189-1.254-1.585-2.238-3.291-1.98s-2.75 1.61-2.56 2.864z",
    fill: "#31c48d",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M127.496 125.082l56.813-11.022 10.527 22.102-58.232 13.053-9.108-24.133z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M155.278 129.327c-.432 2.924 1.994 5.86 5.648 6.4 3.654.541 6.826-1.567 7.259-4.491.432-2.924-1.994-5.86-5.648-6.4-3.654-.541-6.826 1.567-7.259 4.491zm18.88-2.355c-.186 1.255.862 2.604 2.568 2.856 1.707.252 3.1-.735 3.286-1.99.185-1.255-.862-2.604-2.569-2.857-1.707-.252-3.1.736-3.285 1.991zm-32.872 6.463c-.185 1.255.863 2.604 2.569 2.856 1.707.252 3.1-.735 3.286-1.991.185-1.255-.862-2.603-2.569-2.856-1.707-.252-3.1.736-3.286 1.991z",
    fill: "#31c48d",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M127.708 129.034l-.992-1.814c-.628-1.725 1.086-2.88 5.272-5.006 2.165-1.099 4.692-1.479 7.529-.788a.44.44 0 01.17.279l.953 1.567c-.365.784-1.835 2.802-4.788 4.599-2.952 1.797-6.659 1.524-8.144 1.163z",
    fill: "#faca15",
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M126.716 127.22l.992 1.814c1.485.361 5.192.634 8.144-1.163 2.953-1.797 4.423-3.815 4.788-4.599l-1.123-1.846m-12.801 5.794c-.628-1.725 1.086-2.88 5.272-5.006 2.165-1.099 4.692-1.479 7.529-.788m-12.801 5.794c1.979.482 5.815.367 8.024-.668 2.362-1.106 5.778-4.359 4.777-5.126",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M132.745 128.816l56.813-11.021 10.526 22.102-58.231 13.053-9.108-24.134z",
    fill: "#bcf0da",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M160.526 133.062c-.432 2.924 1.994 5.86 5.648 6.4 3.654.541 6.827-1.567 7.259-4.491.433-2.924-1.994-5.86-5.648-6.4-3.654-.541-6.826 1.567-7.259 4.491zm18.88-2.355c-.186 1.255.862 2.603 2.568 2.856 1.707.252 3.1-.736 3.286-1.991.186-1.255-.862-2.603-2.569-2.856-1.706-.252-3.1.735-3.285 1.991zm-32.871 6.463c-.186 1.255.862 2.604 2.568 2.856 1.707.253 3.1-.735 3.286-1.99.186-1.255-.862-2.604-2.569-2.856-1.706-.253-3.1.735-3.285 1.99z",
    fill: "#31c48d",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M126.661 116.33l-.1-1.686c.138-1.494 1.808-1.749 5.644-1.859 1.983-.056 3.982.545 5.838 2.046a.361.361 0 01.028.265l.158 1.491c-.544.452-2.335 1.431-5.144 1.727-2.809.297-5.453-1.199-6.424-1.984z",
    fill: "#e3a008",
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M126.561 114.644l.1 1.686c.971.785 3.615 2.281 6.424 1.984 2.809-.296 4.6-1.275 5.144-1.727l-.186-1.756m-11.482-.187c.138-1.494 1.808-1.749 5.644-1.859 1.983-.056 3.982.545 5.838 2.046m-11.482-.187c1.294 1.046 4.169 2.301 6.162 2.307 2.132.008 5.791-1.203 5.32-2.12",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M148.093 124.761c-5.552 0-7.361-1.854-7.571-2.531V92.97c0-.542 1.514-2.125 7.571-2.125 6.057 0 7.15 1.583 6.94 2.125v29.26c0 .677-1.388 2.531-6.94 2.531z",
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M140.537 93.268c-.173.807 1.036 2.422 7.252 2.422 6.217 0 7.425-1.615 7.253-2.422",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M140.537 105.38c-.173 1.212 1.036 3.634 7.252 3.634m-7.252 2.423c-.173 1.211 1.036 3.028 7.252 3.028m-7.252-.606c-.173.808 1.036 2.423 7.252 2.423m0-16.958c6.216 0 7.425-1.615 7.253-2.423m-7.253 4.846c6.216 0 7.425-2.423 7.253-3.634",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M112.359 118.704c5.552 0 7.361-1.853 7.571-2.531v-29.26c0-.542-1.514-2.124-7.571-2.124-6.057 0-7.151 1.582-6.94 2.124v29.26c0 .678 1.388 2.531 6.94 2.531z",
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M119.915 87.211c.172.808-1.036 2.423-7.252 2.423-6.217 0-7.425-1.615-7.253-2.423",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M119.915 99.324c.172 1.211-1.036 3.633-7.252 3.633m7.252 2.423c.172 1.212-1.036 3.028-7.252 3.028m7.252-.605c.172.807-1.036 2.422-7.252 2.422m0-16.957c-6.217 0-7.425-2.423-7.253-3.634m7.253 6.056c-6.217 0-7.425-2.423-7.253-3.634",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M166.842 122.338c-5.089 0-6.747-2.144-6.94-3.215V72.825c0-.857 1.388-2.572 6.94-2.572 5.553 0 6.555 1.715 6.362 2.572v46.298c0 1.071-1.272 3.215-6.362 3.215z",
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M159.904 128.394c-5.554 0-7.059-1.792-7.269-2.173v-16.474c0-.305 1.211-1.944 7.269-1.944 6.059 0 7.456 1.639 7.246 1.944v16.474c0 .381-1.692 2.173-7.246 2.173z",
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M159.904 128.394c-5.554 0-7.059-1.792-7.269-2.173v-16.474c0-.305 1.211-1.944 7.269-1.944 6.059 0 7.456 1.639 7.246 1.944v16.474c0 .381-1.692 2.173-7.246 2.173zm35.123 1.212c5.554 0 7.059-1.793 7.27-2.174v-23.741c0-.305-1.211-1.944-7.27-1.944-6.059 0-7.456 1.639-7.246 1.944v23.741s1.692 2.174 7.246 2.174z",
    fill: "#e3a008",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M152.65 109.014c-.173 1.211 1.036 3.634 7.252 3.634 6.216 0 7.425-2.423 7.252-3.634m35.127-6.057c.173 1.212-1.036 3.634-7.252 3.634-6.216 0-7.425-2.422-7.252-3.634m-27.861-31.492c-.158 1.211.95 3.634 6.648 3.634 5.698 0 6.806-2.423 6.648-3.634",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M159.915 87.211c-.144.808.863 2.423 6.043 2.423m-6.043 0c-.144.807.863 2.422 6.043 2.422m0-8.479c6.217 0 7.425-1.615 7.253-2.422m-7.253-3.634c6.217 0 7.425-2.423 7.253-3.634M165.958 86c6.217 0 7.425-1.615 7.253-2.422m-7.253 16.957c6.217 0 7.425-2.422 7.253-3.634m-13.309 18.169c6.216 0 7.425-2.422 7.252-3.634m27.875-2.422c-6.216 0-7.425-2.422-7.252-3.634m-27.875 15.141c6.216 0 7.425-1.817 7.252-3.028m27.875-3.028c-6.216 0-7.425-1.817-7.252-3.028m-27.875 10.901c6.216 0 7.425-1.615 7.252-2.423m27.875-3.633c-6.216 0-7.425-1.615-7.252-2.423",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M104.186 123.549c-5.554 0-7.059-1.792-7.27-2.174v-16.473c0-.305 1.211-1.945 7.27-1.945 6.058 0 7.456 1.64 7.246 1.945v16.473c0 .382-1.692 2.174-7.246 2.174z",
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M96.932 105.38c-.173.808 1.036 2.423 7.252 2.423 6.216 0 7.425-1.615 7.252-2.423",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M104.184 110.225c6.216 0 7.425-2.422 7.252-3.634m-7.252 9.085c6.216 0 7.425-1.817 7.252-3.028m-7.252 4.845c6.216 0 7.425-1.615 7.252-2.423",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M124.777 123.549c-5.554 0-7.059-1.792-7.269-2.174v-16.473c0-.305 1.211-1.945 7.269-1.945 6.059 0 7.456 1.64 7.246 1.945v16.473c0 .382-1.692 2.174-7.246 2.174z",
    fill: "#e3a008",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M117.523 105.38c-.173.808 1.036 2.423 7.252 2.423 6.216 0 7.425-1.615 7.252-2.423",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M124.775 110.225c6.216 0 7.425-2.422 7.252-3.634m-7.252 9.085c6.216 0 7.425-1.817 7.252-3.028m-7.252 4.845c6.216 0 7.425-1.615 7.252-2.423",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M110.31 112.268l1.774-1.062c1.7-.694 2.92.975 5.206 5.076 1.182 2.12 1.659 4.631 1.078 7.493a.442.442 0 01-.272.18l-1.529 1.013c-.798-.335-2.872-1.725-4.781-4.607-1.91-2.881-1.779-6.596-1.476-8.093z",
    fill: "#e3a008",
    fillRule: "nonzero"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M112.084 111.206l-1.774 1.062c-.303 1.497-.434 5.212 1.476 8.093 1.909 2.882 3.983 4.272 4.781 4.607l1.801-1.193m-6.284-12.569c1.7-.694 2.92.975 5.206 5.076 1.182 2.12 1.659 4.631 1.078 7.493m-6.284-12.569c-.404 1.997-.142 5.825.977 7.992 1.196 2.318 4.578 5.606 5.307 4.577",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M136.071 127.731l-.122-2.064c.169-1.828 2.213-2.14 6.906-2.274 2.426-.069 4.873.667 7.144 2.504a.441.441 0 01.034.324l.193 1.824c-.666.553-2.857 1.75-6.294 2.114-3.438.363-6.673-1.468-7.861-2.428z",
    fill: "#e3a008",
    fillRule: "nonzero"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M135.949 125.667l.122 2.064c1.188.96 4.423 2.791 7.861 2.428 3.437-.364 5.628-1.561 6.294-2.114l-.227-2.148m-14.05-.23c.169-1.828 2.213-2.14 6.906-2.274 2.426-.069 4.873.667 7.144 2.504m-14.05-.23c1.584 1.281 5.101 2.815 7.54 2.824 2.609.009 7.086-1.473 6.51-2.594",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M185.976 134.86l-.123-2.064c.169-1.828 2.213-2.14 6.906-2.274 2.426-.069 4.873.667 7.144 2.504a.437.437 0 01.034.324l.193 1.825c-.666.553-2.856 1.75-6.294 2.113-3.438.363-6.673-1.467-7.86-2.428z",
    fill: "#e3a008",
    fillRule: "nonzero"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M185.853 132.796l.123 2.064c1.187.961 4.422 2.791 7.86 2.428 3.438-.363 5.628-1.56 6.294-2.113l-.227-2.149m-14.05-.23c.169-1.828 2.213-2.14 6.906-2.274 2.426-.069 4.873.667 7.144 2.504m-14.05-.23c1.584 1.281 5.101 2.816 7.54 2.824 2.609.009 7.086-1.473 6.51-2.594",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M178.127 135.061l-.854-1.883c-.498-1.768 1.299-2.791 5.632-4.598 2.24-.935 4.788-1.125 7.566-.224a.437.437 0 01.149.291l.833 1.634c-.423.755-2.039 2.657-5.118 4.229-3.079 1.571-6.755 1.022-8.208.551z",
    fill: "#faca15",
    fillRule: "nonzero"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M177.273 133.178l.854 1.883c1.453.471 5.129 1.02 8.208-.551 3.079-1.572 4.695-3.474 5.118-4.229l-.982-1.925m-13.198 4.822c-.498-1.768 1.299-2.791 5.632-4.598 2.24-.935 4.788-1.125 7.566-.224m-13.198 4.822c1.938.628 5.771.8 8.051-.067 2.439-.926 6.087-3.915 5.147-4.755",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M150.345 139.011l-.154-2.062c.141-1.83 2.18-2.174 6.87-2.38 2.425-.107 4.883.592 7.182 2.393a.438.438 0 01.039.324l.221 1.821c-.657.563-2.829 1.794-6.261 2.21-3.431.417-6.694-1.364-7.897-2.306z",
    fill: "#e3a008",
    fillRule: "nonzero"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M150.191 136.949l.154 2.062c1.203.942 4.466 2.723 7.897 2.306 3.432-.416 5.604-1.647 6.261-2.21l-.26-2.145m-14.052-.013c.141-1.83 2.18-2.174 6.87-2.38 2.425-.107 4.883.592 7.182 2.393m-14.052-.013c1.604 1.257 5.144 2.737 7.583 2.708 2.608-.032 7.063-1.583 6.469-2.695",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M145.051 144.079l-1.343-1.572c-.97-1.559.471-3.041 4.131-5.982 1.892-1.52 4.287-2.411 7.206-2.319.107.052.18.133.223.238l1.255 1.338c-.196.843-1.22 3.12-3.74 5.485-2.521 2.366-6.205 2.86-7.732 2.812z",
    fill: "#faca15",
    fillRule: "nonzero"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M143.708 142.507l1.343 1.572c1.527.048 5.211-.446 7.732-2.812 2.52-2.365 3.544-4.642 3.74-5.485l-1.478-1.576m-11.337 8.301c-.97-1.559.471-3.041 4.131-5.982 1.892-1.52 4.287-2.411 7.206-2.319m-11.337 8.301c2.035.065 5.765-.835 7.715-2.302 2.084-1.568 4.758-5.453 3.622-5.999",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M97.386 137.992l-.154-2.061c.141-1.831 2.18-2.174 6.87-2.38 2.425-.107 4.883.591 7.182 2.393a.437.437 0 01.039.324l.221 1.821c-.657.563-2.829 1.794-6.261 2.21-3.432.416-6.694-1.364-7.897-2.307z",
    fill: "#e3a008",
    fillRule: "nonzero"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M97.232 135.931l.154 2.061c1.203.943 4.465 2.723 7.897 2.307 3.432-.416 5.604-1.647 6.261-2.21l-.26-2.145m-14.052-.013c.141-1.831 2.18-2.174 6.87-2.38 2.425-.107 4.883.591 7.182 2.393m-14.052-.013c1.604 1.256 5.144 2.736 7.583 2.707 2.608-.031 7.062-1.582 6.469-2.694",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M99.423 133.919l-.154-2.062c.141-1.831 2.179-2.174 6.87-2.38 2.425-.107 4.883.592 7.182 2.393a.443.443 0 01.039.324l.221 1.821c-.657.563-2.829 1.794-6.261 2.21-3.432.416-6.694-1.364-7.897-2.306z",
    fill: "#faca15",
    fillRule: "nonzero"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M99.269 131.857l.154 2.062c1.203.942 4.465 2.722 7.897 2.306 3.432-.416 5.604-1.647 6.261-2.21l-.26-2.145m-14.052-.013c.141-1.831 2.179-2.174 6.87-2.38 2.425-.107 4.883.592 7.182 2.393m-14.052-.013c1.603 1.256 5.143 2.737 7.583 2.707 2.608-.031 7.062-1.582 6.469-2.694",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M104.175 134.478l.626-1.97c.814-1.646 2.833-1.204 7.262.356 2.289.806 4.309 2.371 5.769 4.901a.44.44 0 01-.084.315l-.475 1.771c-.82.278-3.294.609-6.633-.286s-5.702-3.764-6.465-5.087z",
    fill: "#e3a008",
    fillRule: "nonzero"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M104.801 132.508l-.626 1.97c.763 1.323 3.126 4.192 6.465 5.087 3.339.895 5.813.564 6.633.286l.559-2.086m-13.031-5.257c.814-1.646 2.833-1.204 7.262.356 2.289.806 4.309 2.371 5.769 4.901m-13.031-5.257c1.019 1.764 3.75 4.458 6.024 5.342 2.432.944 7.143 1.168 7.007-.085",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M183.492 51.034l-1.083-3.335-4.332-1.111h-3.249l-4.332 1.111-1.083 3.335 6.211 5.34.828.773.828-.773 6.212-5.34z",
    fill: "#cce7ff",
    fillRule: "nonzero"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M183.492 51.034l-1.083-3.335-4.332-1.111m5.415 4.446h-3.705m3.705 0l-6.212 5.34m.797-9.786h-3.249m3.249 0l1.71 4.446m-4.959-4.446l-4.332 1.111-1.083 3.335m5.415-4.446l-1.71 4.446m-3.705 0h3.705m-3.705 0l6.211 5.34m-2.506-5.34l2.506 5.34m-2.506-5.34h6.669m-4.163 5.34l.828.773.828-.773m2.507-5.34l-2.507 5.34",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M176.249 43.17v-1.987m-7.058 4.454a19.073 19.073 0 00-.701-.67c-.133-.12-.304-.174-.396-.358m16.172 1.097c.17-.234.303-.425.549-.583.127-.081.277-.177.342-.308m.892 5.551c.582 0 1.14-.069 1.713-.069m-20.833.617c-.391-.009-.774-.069-1.165-.069",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M149 9.085c-42.451 0-76.915 34.464-76.915 76.915 0 42.451 34.464 76.916 76.915 76.916 42.451 0 76.916-34.465 76.916-76.916 0-42.451-34.465-76.915-76.916-76.915zm0 16.957c-33.092 0-59.958 26.866-59.958 59.958s26.866 59.958 59.958 59.958S208.958 119.092 208.958 86 182.092 26.042 149 26.042z",
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "matrix(-1 0 0 1 148.394 155.042)"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "matrix(-1 0 0 1 148.394 16.958)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "matrix(0 -1 -1 0 79.958 86)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "matrix(0 -1 -1 0 216.831 86)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "scale(1 -1) rotate(45 96.1 99.823)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "scale(1 -1) rotate(45 261.576 171.745)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "scale(1 -1) rotate(-45 52.795 -257.931)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    r: 1.817,
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "scale(1 -1) rotate(-45 -113.034 -186.155)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M227.127 51.479h-15.746v75.099h15.746z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M238.792 9.085c.146.107.298.223.454.35 1.698 1.38 3.924 3.963 6.211 8.796 4.569 9.654 9.42 28.374 10.739 64.719 1.211 33.371-3.337 53.599-8.223 65.509-2.443 5.956-4.97 9.83-6.901 12.225a24.648 24.648 0 01-2.018 2.232h16.441l.073-.029a4.48 4.48 0 00.507-.249c.451-.255 1.119-.709 1.936-1.493 1.632-1.57 3.861-4.468 6.107-9.746 4.496-10.567 9.036-30.611 9.036-68.427 0-34.165-5.292-52.679-10.528-62.628-2.616-4.971-5.217-7.801-7.136-9.382-.96-.791-1.752-1.271-2.294-1.551-.271-.14-.48-.23-.616-.284l-.114-.042h-13.674z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M218.648 86c0 21.372 2.167 40.701 5.659 54.669 1.747 6.989 3.818 12.601 6.094 16.452 2.3 3.892 4.692 5.795 7.022 5.795 2.329 0 4.722-1.903 7.022-5.795 2.276-3.851 4.347-9.463 6.094-16.452 3.492-13.968 5.659-33.297 5.659-54.669s-2.167-40.701-5.659-54.669c-1.747-6.988-3.818-12.601-6.094-16.452-2.3-3.891-4.693-5.794-7.022-5.794-2.33 0-4.722 1.903-7.022 5.794-2.276 3.851-4.347 9.464-6.094 16.452-3.492 13.968-5.659 33.297-5.659 54.669z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M217.437 84.789c0 19.7 1.963 37.515 5.127 50.388 1.583 6.441 3.458 11.611 5.518 15.156 2.085 3.588 4.239 5.315 6.313 5.315 2.073 0 4.227-1.727 6.312-5.315 2.06-3.545 3.936-8.715 5.519-15.156 3.163-12.873 5.126-30.688 5.126-50.388 0-19.701-1.963-37.516-5.126-50.389-1.583-6.441-3.459-11.611-5.519-15.156-2.085-3.588-4.239-5.315-6.312-5.315-2.074 0-4.228 1.727-6.313 5.315-2.06 3.545-3.935 8.715-5.518 15.156-3.164 12.873-5.127 30.688-5.127 50.389z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M235 85.394c1.181-.918 3.634-1.211 3.634-1.211v6.056s-2.395.692-3.634 0c-1.032-.576-1.817-1.569-1.817-2.422 0-.853.884-1.697 1.817-2.423z",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21,
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M216.226 86c0 8.323.945 15.836 2.461 21.249.759 2.711 1.651 4.861 2.617 6.319.981 1.481 1.937 2.108 2.795 2.108.858 0 1.815-.627 2.795-2.108.966-1.458 1.858-3.608 2.617-6.319 1.516-5.413 2.461-12.926 2.461-21.249 0-8.323-.945-15.836-2.461-21.249-.759-2.711-1.651-4.861-2.617-6.319-.98-1.481-1.937-2.108-2.795-2.108-.858 0-1.814.627-2.795 2.108-.966 1.458-1.858 3.608-2.617 6.319-1.516 5.413-2.461 12.926-2.461 21.249z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M224.099 56.324h6.662s6.662 2.422 6.662 29.676c0 27.253-6.662 29.676-6.662 29.676h-6.662",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M212.592 86c0 4.305.537 8.179 1.392 10.956.428 1.393.926 2.475 1.451 3.197.534.734 1.014.988 1.396.988.383 0 .862-.254 1.396-.988.525-.722 1.023-1.804 1.451-3.197.855-2.777 1.393-6.651 1.393-10.956s-.538-8.179-1.393-10.956c-.428-1.393-.926-2.475-1.451-3.197-.534-.734-1.013-.988-1.396-.988-.382 0-.862.254-1.396.988-.525.722-1.023 1.804-1.451 3.197-.855 2.777-1.392 6.651-1.392 10.956z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M216.831 70.253h3.634s3.634 1.286 3.634 15.747-3.634 15.746-3.634 15.746h-3.634m12.113-56.323v10.901h-4.845V45.423s0-.606 2.423-.606c2.422 0 2.422.606 2.422.606zm0 70.253v10.902s0 .605-2.422.605c-2.423 0-2.423-.605-2.423-.605v-10.902h4.845z",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    r: 3.028,
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.21,
    transform: "matrix(-1 0 0 1 238.634 87.211)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M233.789 65.408l1.817-1.817 3.634 4.24-4.845 2.784s-.606 0-1.817-1.816c-1.063-1.594 1.211-3.391 1.211-3.391z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M235.747 66.482c-.387-.67-.571-1.405-.528-2.067.042-.658.32-1.318.938-1.675.617-.356 1.328-.267 1.919.025.595.295 1.139.821 1.526 1.491.387.67.571 1.405.528 2.067-.042.658-.32 1.319-.938 1.675-.617.357-1.328.267-1.919-.025-.595-.294-1.139-.821-1.526-1.491zm.987 38.39l2.095 1.932-4.434 4.028-2.534-4.028s-1.1-1.423.717-2.634c1.817-1.212 4.156.702 4.156.702z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M234.992 107.04c.547-.547 1.209-.915 1.86-1.045.646-.129 1.356-.031 1.86.473s.602 1.214.472 1.86c-.13.651-.498 1.313-1.045 1.86-.547.547-1.209.915-1.86 1.045-.646.129-1.356.032-1.86-.472s-.602-1.215-.472-1.861c.13-.65.497-1.312 1.045-1.86z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ec4f6",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M55.127 24.832H.62v121.127h54.507z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21,
    d: "M25.451 59.352h4.845v64.197h-4.845z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M29.936 123.146l6.416 2.355v11.776H19.394v-11.776l6.875-2.355h3.667zm-1.146 3.768l2.852 1.099v5.495h-7.537v-5.495l3.056-1.099h1.629z",
    fill: "#bcf0da"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M36.352 125.501l.209-.569.397.146v.423h-.606zm-6.416-2.355v-.606h.107l.101.037-.208.569zm6.416 14.131h.606v.606h-.606v-.606zm-16.958 0v.606h-.605v-.606h.605zm0-11.776h-.605v-.433l.409-.14.196.573zm6.875-2.355l-.196-.573.095-.033h.101v.606zm5.373 4.867l.218-.565.388.149v.416h-.606zm-2.852-1.099v-.606h.113l.105.04-.218.566zm2.852 6.594h.606v.606h-.606v-.606zm-7.537 0v.606h-.606v-.606h.606zm0-5.495h-.606v-.426l.401-.144.205.57zm3.056-1.099l-.205-.57.099-.036h.106v.606zm8.982-.845l-6.416-2.355.417-1.137 6.417 2.355-.418 1.137zm-.397 11.208v-11.776h1.212v11.776h-1.212zm-16.352-.606h16.958v1.212H19.394v-1.212zm.606-11.17v11.776h-1.211v-11.776H20zm6.465-1.783l-6.874 2.356-.393-1.146 6.875-2.355.392 1.145zm3.471.033h-3.667v-1.211h3.667v1.211zm1.488 4.827l-2.852-1.099.436-1.131 2.852 1.1-.436 1.13zm-.388 4.93v-5.495h1.212v5.495h-1.212zm-6.931-.605h7.537v1.211h-7.537v-1.211zm.606-4.89v5.495h-1.212v-5.495h1.212zm2.655-.53l-3.056 1.1-.41-1.14 3.056-1.099.41 1.139zm1.424.036h-1.629v-1.211h1.629v1.211z",
    fill: "#18191b",
    fillRule: "nonzero"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M14.549 62.986h26.648v-18.93s-3.331-10.14-13.324-10.14c-10.659 0-13.324 10.14-13.324 10.14v18.93z",
    fill: "#def7ec",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M24.239 65.408h7.268v-9.397l-3.634-1.504-3.634 1.504v9.397z",
    fill: "#def7ec",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M24.239 123.549h7.268v-9.398h-7.268v9.398z",
    fill: "#84e1bc",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.21
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M27.873 38.761v10.901m-3.634-7.267v4.845m7.268-4.845v4.845",
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.21
  })));
}
export default SvgShovelVault;